/**
 * Pinia Reset Plugin
 *
 * Adds $reset() support to all Pinia stores, including setup syntax stores.
 * Setup stores don't have built-in $reset - Pinia only adds a stub that throws an error.
 *
 * How it works:
 * 1. Captures initial state when store is created
 * 2. Provides $reset() method to restore initial state
 * 3. Uses cloneDeep to avoid reference issues
 *
 * @see https://pinia.vuejs.org/core-concepts/plugins.html
 * @see https://github.com/vuejs/pinia/discussions/911
 */
import { cloneDeep } from 'lodash';

export const piniaResetPlugin = ({ store }) => {
  // Capture initial state as deep copy
  const initialState = cloneDeep(store.$state);

  // Override $reset for all stores (setup and options API)
  store.$reset = () => {
    store.$patch(cloneDeep(initialState));
  };
};
